// VersioniIRi.jsx — dritarja «Ka version të ri» dhe ekrani «Kërkohet përditësim».
// Logjika: versioni.js. Politika: Admin Center → kartela «Versioni i aplikacionit».
//
// Vetëdrejtuar, si AppLock: kur s'ka çfarë të tregojë (shfletues, version i
// përditësuar, s'ka politikë, s'ka rrjet) nuk vizaton asgjë fare.

import React, { useCallback, useEffect, useRef, useState } from "react";
import { App as CapacitorApp } from "@capacitor/app";
import { SAFE_TOP, SAFE_BOTTOM } from "./zonaESigurt";
import {
  eshteNative, platformaNative, versioniIInstaluar, merrPolitiken,
  vleresoPolitiken, eShtyre, shtyje,
} from "./versioni";

const GRUMBULLI_MS = 6 * 60 * 60 * 1000;   // jo më shpesh se një herë në 6 orë

export default function VersioniIRi({ C, F, t }) {
  const [gjendja, setGjendja] = useState(null);   // { niveli, eFundit, mesazhi, url } | null
  const kontrolluarMe = useRef(0);
  const gjendjaRef = useRef(null);
  gjendjaRef.current = gjendja;

  const kontrollo = useCallback(async () => {
    if (!eshteNative()) return;
    // I bllokuari rikontrollohet gjithmonë (njeriu mund të ketë kthyer nga dyqani);
    // pjesa tjetër respekton afatin.
    const bllok = gjendjaRef.current && gjendjaRef.current.niveli === "bllok";
    if (!bllok && kontrolluarMe.current && Date.now() - kontrolluarMe.current < GRUMBULLI_MS) return;
    const instaluar = await versioniIInstaluar();
    if (!instaluar) return;
    const politika = await merrPolitiken();
    if (!politika) return;   // s'ka rrjet / s'ka SQL → asnjë bllokim
    kontrolluarMe.current = Date.now();
    const r = vleresoPolitiken(politika, instaluar, platformaNative());
    if (!r) { setGjendja(null); return; }
    if (r.niveli === "buta" && eShtyre(r.eFundit)) { setGjendja(null); return; }
    setGjendja(r);
  }, []);

  useEffect(() => {
    if (!eshteNative()) return undefined;
    kontrollo();
    // Pastrimi pret premtimin (shih `dëgjoResume` te App.jsx, SIGURIA2/U5).
    let doreza = null;
    let hequr = false;
    try {
      Promise.resolve(CapacitorApp.addListener("resume", () => { kontrollo(); }))
        .then((h) => { if (hequr) { try { h?.remove?.(); } catch (_e) { /* asgjë */ } } else doreza = h; })
        .catch(() => {});
    } catch (_e) { /* jo native */ }
    return () => { hequr = true; try { doreza?.remove?.(); } catch (_e) { /* asgjë */ } };
  }, [kontrollo]);

  if (!gjendja) return null;
  const bllok = gjendja.niveli === "bllok";

  const hapDyqanin = () => {
    // Capacitor i hap lidhjet e jashtme me sistemin (Play / App Store), jo brenda WebView-it.
    try { window.location.href = gjendja.url; } catch (_e) { /* asgjë */ }
  };
  const meVone = () => { shtyje(gjendja.eFundit); setGjendja(null); };

  const butoniKryesor = {
    width: "100%", padding: "13px 14px", borderRadius: 12, cursor: "pointer",
    background: C.gold, color: C.bgDeep, border: "none",
    fontFamily: F.body, fontSize: 14, fontWeight: 700,
  };
  const butoniDyte = {
    width: "100%", padding: "13px 14px", borderRadius: 12, cursor: "pointer", marginTop: 10,
    background: "transparent", color: C.ink, border: `1px solid ${C.goldSoft}`,
    fontFamily: F.body, fontSize: 14, fontWeight: 600,
  };
  const titulli = { fontFamily: F.display || F.body, fontSize: 18, color: C.ink, marginBottom: 6 };
  const teksti = { fontFamily: F.body, fontSize: 12.5, color: C.inkLight, lineHeight: 1.6, marginBottom: 16 };

  const trupi = (
    <>
      <div style={titulli}>{bllok ? t("Update required") : t("A new version is available")}</div>
      <div style={teksti}>
        {bllok
          ? t("This version of the app is no longer supported. Please update to continue.")
          : t("Update the app to get the latest improvements and fixes.")}
        {gjendja.mesazhi ? <><br />{gjendja.mesazhi}</> : null}
      </div>
      <button type="button" onClick={hapDyqanin} style={butoniKryesor}>{t("Update")}</button>
      {!bllok && <button type="button" onClick={meVone} style={butoniDyte}>{t("Later")}</button>}
    </>
  );

  if (bllok) {
    return (
      <div role="alertdialog" aria-modal="true" style={{
        position: "fixed", inset: 0, zIndex: 100001, background: C.panel,
        display: "flex", alignItems: "center", justifyContent: "center",
        padding: `calc(24px + ${SAFE_TOP}) 24px calc(24px + ${SAFE_BOTTOM})`,
      }}>
        <div style={{ width: "100%", maxWidth: 420 }}>{trupi}</div>
      </div>
    );
  }

  return (
    <div role="dialog" aria-modal="true" style={{
      position: "fixed", inset: 0, zIndex: 99998, background: "rgba(0,0,0,.55)",
      display: "flex", alignItems: "flex-end", justifyContent: "center",
    }}>
      <div style={{
        width: "100%", maxWidth: 460, background: C.panel, borderTopLeftRadius: 18, borderTopRightRadius: 18,
        padding: `22px 20px calc(22px + ${SAFE_BOTTOM})`, border: `1px solid ${C.goldSoft}`,
      }}>
        {trupi}
      </div>
    </div>
  );
}
